import { UpdateTypeSlug } from "./types"

export const UPDATE_TYPES: { slug: UpdateTypeSlug, name: string, color: string }[] = [
  { slug: "new-feature", name: "New Feature", color: "#ff3b92" },
  { slug: "improvement", name: "Improvement", color: "#e48e26" },
  { slug: "fix", name: "Fix", color: "#008856" },
  { slug: "announcement", name: "Announcement", color: "#914de6" },
]

export const updateType = (slug: string) => UPDATE_TYPES.find((type) => type.slug === slug)

export const isUpdateTypeSlug = (slug: string): slug is UpdateTypeSlug => (
  updateType(slug) !== undefined
)

const dayFormat = new Intl.DateTimeFormat("en-US", {
  timeZone: "America/New_York",
  year: "numeric",
  month: "long",
  day: "numeric",
})

// New York's calendar, as on d.io/updates: a post published late in the evening keeps its day
export const formatUpdateDay = (iso: string) => dayFormat.format(new Date(iso))
